export default __webpack_public_path__ + "static/media/dream.90848b5c.svg";